import styles from "styles/styles.module.css";
import { POLICY_STATUS_EDIT } from "../Constants/PolicyTranslationConstants";
import { isVarianceRule } from "../Utils/TranslationUtils";
export const renderError = (fieldName, row) => {
  return row.errors?.[fieldName] || null;
};
export const renderCellClass = ({ colDef: { field }, row }) =>
  row?.errors?.[field] ? styles["error-cell"] : "";

export const renderValidationError = (params, validationErrors) => {
  const cellElement = params.api.getCellElement(params.id, params.field);
  const errorText = params.api.getColumn(params.field).errorText;
  const error = validationErrors.find(
    (item) =>
      item.cellField === params.field &&
      params.row.id === item.rowId &&
      !item.isValid &&
      item.errorMessage
  );
  if (error && cellElement) {
    cellElement.classList.add("validationError");
  } else if (cellElement) {
    cellElement.classList.remove("validationError");
  }
  return error ? errorText : null;
};

export const isSameCell = (data, item) =>
  item.cellField === data.cellField && item.rowId === data.rowId;

/**
 * @deprecated this function wrongly sets the validation error
 */
export const updateValidationErrors = (data, setValidationErrors) => {
  console.warn("Warning: this function is deprecated and should not be used");
  const clonedData = { ...data };
  setValidationErrors((validationErrors) => {
    const index = validationErrors.findIndex((item) =>
      isSameCell(clonedData, item)
    );
    if (index === -1) {
      return [...validationErrors, clonedData];
    }
    if (validationErrors[index].errorMessage !== clonedData.errorMessage) {
      const updatedErrors = [...validationErrors];
      updatedErrors[index] = clonedData;
      return updatedErrors;
    }
    return validationErrors;
  });
};

export const clearValidationErrors = (data, setValidationErrors) => {
  setValidationErrors((validationErrors) => {
    const exists = validationErrors.find((item) => isSameCell(data, item));
    if (exists) {
      return validationErrors.filter((item) => !isSameCell(data, item));
    }
    return validationErrors;
  });
};

export const ccregex = /^[a-zA-Z0-9]+(,[a-zA-Z0-9]+)*$/;

const getLob = (lobList, id) => {
  return lobList.find((lob) => lob.id.toString() === id.toString());
};
const validateLobADOPT = (row, lobAdoptionDecisionList, errors) => {
  if (
    isVarianceRule(row) &&
    row.RuleFacts.LobConfigKey &&
    !row.RuleFacts.RuleEndDate
  ) {
    if (Array.isArray(row.RuleFacts?.LobConfigKey)) {
      row.RuleFacts.LobConfigKey.forEach((lob) => {
        const decision = getLob(lobAdoptionDecisionList, lob.LobConfigKey);
        if (decision?.adoptionDecision === "ADOPT") {
          errors.LobDisplayName =
            decision.lobDesc + " cannot have an active variance";
        }
      });
    }
  }
};
const validateLobDONOTADOPT = (row, lobAdoptionDecisionList, errors) => {
  if (
    Array.isArray(row.RuleFacts?.LobConfigKey) &&
    !row.RuleFacts.RuleEndDate
  ) {
    row.RuleFacts.LobConfigKey.forEach((lob) => {
      const decision = getLob(lobAdoptionDecisionList, lob.LobConfigKey);
      if (decision?.adoptionDecision === "DO_NOT_ADOPT") {
        errors.LobDisplayName = decision.lobDesc + " cannot have active rules";
      }
    });
  }
};

const skipValidationForImmutables = (row) => {
  const skip =
    row.RuleHeader?.EditRule === POLICY_STATUS_EDIT ||
    !row.RuleHeader?.EditRule;
  if (skip) {
    const { errors, ...rest } = row;
    return [skip, rest];
  }
  return [skip, null];
};

export const validatePXDX = (lobAdoptionDecisionList, row) => {
  const [skip, skippedRow] = skipValidationForImmutables(row);
  if (skip) {
    return skippedRow;
  }

  const ageLow = row.RuleFacts.ageLow;
  const ageHigh = row.RuleFacts.ageHigh;
  const errors = {};
  if (!row.RuleFacts.RuleEffectiveDate)
    errors.startDate = "Effective Date Required";
  if (!row.RuleFacts.CoverageCriteriaList) {
    errors.CoverageCriteriaList = "CC required";
  }
  if (
    row.RuleFacts.CoverageCriteriaList &&
    !ccregex.test(row.RuleFacts.CoverageCriteriaList)
  ) {
    errors.CoverageCriteriaList = "Comma separate";
  }
  if (!row.RuleFacts.DXDisplayValueKey) {
    errors.dxLimitation = "Dx Limitation required";
  }

  if (
    !row.RuleFacts.ageLow &&
    !row.RuleFacts.ageHigh &&
    !row.RuleFacts.DisplayGender &&
    row.RuleFacts.DisplayAgeGenderRule
  ) {
    errors.coveredGender = "Age or Gender is required";
    errors.ageLow = "Required";
    errors.ageHigh = "Required";
  }

  if (!row.RuleFacts.ageLow && row.RuleFacts.ageHigh)
    errors.ageLow = "Required";
  if (row.RuleFacts.ageLow && !row.RuleFacts.ageHigh)
    errors.ageHigh = "Required";

  if (
    (row.RuleFacts.ageLow ||
      row.RuleFacts.ageHigh ||
      row.RuleFacts.DisplayGender) &&
    !row.RuleFacts.DisplayAgeGenderRule
  )
    errors.genderAgeMeetsCC = "Required";

  if (
    ageLow &&
    ageHigh &&
    parseInt(ageLow) !== 0 &&
    parseInt(ageHigh) !== 150
  ) {
    errors.ageLow = "Create 2nd Age Rule";
    errors.ageHigh = "Create 2nd Age Rule";
  }
  validateLobADOPT(row, lobAdoptionDecisionList, errors);
  validateLobDONOTADOPT(row, lobAdoptionDecisionList, errors);

  return { ...row, errors };
};

export const validatedHistoryTranslation = (lobAdoptionDecisionList, row) => {
  const [skip, skippedRow] = skipValidationForImmutables(row);
  if (skip) {
    return skippedRow;
  }
  const ageLow = row.RuleFacts.ageLow;
  const ageHigh = row.RuleFacts.ageHigh;
  const errors = {};
  if (!row.RuleFacts.RuleEffectiveDate) {
    errors.startDate = "Effective Date Required";
  }

  if (
    !row.RuleFacts.ageLow &&
    !row.RuleFacts.ageHigh &&
    !row.RuleFacts.DisplayGender &&
    row.RuleFacts.DisplayAgeGenderRule
  ) {
    errors.coveredGender = "Age or Gender is required";
    errors.coveredAgeRange = "Required";
  }

  if (!row.RuleFacts.ageLow && row.RuleFacts.ageHigh)
    errors.coveredAgeRange = "Age Low Required";
  if (row.RuleFacts.ageLow && !row.RuleFacts.ageHigh)
    errors.coveredAgeRange = "Age High Required";

  if (
    (row.RuleFacts.ageLow ||
      row.RuleFacts.ageHigh ||
      row.RuleFacts.DisplayGender) &&
    !row.RuleFacts.DisplayAgeGenderRule
  )
    errors.genderAgeMeetsCC = "Required";

  if (
    ageLow &&
    ageHigh &&
    parseInt(ageLow) !== 0 &&
    parseInt(ageHigh) !== 150
  ) {
    errors.coveredAgeRange = "Create 2nd Age Rule";
  }
  validateLobADOPT(row, lobAdoptionDecisionList, errors);
  validateLobDONOTADOPT(row, lobAdoptionDecisionList, errors);

  return { ...row, errors };
};

export const validatedDependency = (lobAdoptionDecisionList, row) => {
  const [skip, skippedRow] = skipValidationForImmutables(row);
  if (skip) {
    return skippedRow;
  }
  const errors = {};
  if (!row.RuleFacts.CoverageCriteriaList) {
    errors.CoverageCriteriaList = "CC required";
  }
  if (
    row.RuleFacts.CoverageCriteriaList &&
    !ccregex.test(row.RuleFacts.CoverageCriteriaList)
  ) {
    errors.CoverageCriteriaList = "Comma separate";
  }
  if (!row.RuleFacts.RuleEffectiveDate)
    errors.startDate = "Effective Date Required";
  if (!row.RuleFacts.DependencyProcedureCode)
    errors.DependencyProcedureCode = "Procedure code Required";
  validateLobADOPT(row, lobAdoptionDecisionList, errors);
  validateLobDONOTADOPT(row, lobAdoptionDecisionList, errors);

  return { ...row, errors };
};

export const validatedDemographics = (lobAdoptionDecisionList, row) => {
  const [skip, skippedRow] = skipValidationForImmutables(row);
  if (skip) {
    return skippedRow;
  }
  const errors = {};
  const ageLow = row.RuleFacts.ageLow;
  const ageHigh = row.RuleFacts.ageHigh;

  if (!row.RuleFacts.CoverageCriteriaList) {
    errors.CoverageCriteriaList = "CC required";
  }
  if (
    row.RuleFacts.CoverageCriteriaList &&
    !ccregex.test(row.RuleFacts.CoverageCriteriaList)
  ) {
    errors.CoverageCriteriaList = "Comma separate";
  }

  if (
    !row.RuleFacts.ageLow &&
    !row.RuleFacts.ageHigh &&
    !row.RuleFacts.DisplayGender
  ) {
    errors.coveredGender = "Age or Gender is required";
    errors.ageLow = "Required";
    errors.ageHigh = "Required";
  }

  if (!row.RuleFacts.ageLow && row.RuleFacts.ageHigh)
    errors.ageLow = "Required";
  if (row.RuleFacts.ageLow && !row.RuleFacts.ageHigh)
    errors.ageHigh = "Required";

  if (
    (row.RuleFacts.ageLow ||
      row.RuleFacts.ageHigh ||
      row.RuleFacts.DisplayGender) &&
    !row.RuleFacts.DisplayAgeGenderRule
  )
    errors.genderAgeMeetsCC = "Required";
  if (
    ageLow &&
    ageHigh &&
    parseInt(ageLow) !== 0 &&
    parseInt(ageHigh) !== 150
  ) {
    errors.ageLow = "Create 2nd Age Rule";
    errors.ageHigh = "Create 2nd Age Rule";
  }

  if (!row.RuleFacts.RuleEffectiveDate)
    errors.startDate = "Effective Date Required";
  validateLobADOPT(row, lobAdoptionDecisionList, errors);
  validateLobDONOTADOPT(row, lobAdoptionDecisionList, errors);

  return { ...row, errors };
};

export const validatedIncompatibility = (lobAdoptionDecisionList, row) => {
  const [skip, skippedRow] = skipValidationForImmutables(row);
  if (skip) {
    return skippedRow;
  }
  const errors = {};
  if (!row.RuleFacts.CoverageCriteriaList) {
    errors.CoverageCriteriaList = "CC required";
  }
  if (
    row.RuleFacts.CoverageCriteriaList &&
    !ccregex.test(row.RuleFacts.CoverageCriteriaList)
  ) {
    errors.CoverageCriteriaList = "Comma separate";
  }
  if (!row.RuleFacts.MutuallyExclusivewithSameClaim) {
    errors.procedureCodeExists = "Procedure Code Required";
  }

  if (!row.RuleFacts.RuleEffectiveDate) {
    errors.startDate = "Effective Date Required";
  }
  validateLobADOPT(row, lobAdoptionDecisionList, errors);
  validateLobDONOTADOPT(row, lobAdoptionDecisionList, errors);

  return { ...row, errors };
};
